import React from 'react';
import { Form, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

interface FileUploadFormItemProps {
    required: boolean;
    label: string;
    name: string;
}

export const FileUploadFormItem = ({ required, label, name }: FileUploadFormItemProps) => (
    <Form.Item
        label={label}
        name={name}
        valuePropName="fileList"
        getValueFromEvent={(e) => e.fileList}
        rules={[
            {
                required: required,
                message: 'Пожалуйста, выберите файл',
            },
        ]}
    >
        <Upload
            beforeUpload={() => false}
            maxCount={1}
        >
            <Button
                icon={<UploadOutlined />}
                color="blue"
            >
                Выберите файл
            </Button>
        </Upload>
    </Form.Item>
);
